import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Short personalised-link path for SMS: /s/<token>
 *
 * Keeps the minted URL tiny while the prefill snapshot stays server-side.
 * Hands the token to the calculator as `?k=`, which resolves it as usual.
 */
export const Route = createFileRoute("/s/$token")({
  beforeLoad: ({ params }) => {
    const token = typeof params.token === "string" ? params.token.trim() : "";
    const valid = /^[A-Za-z0-9_-]{8,200}$/.test(token);
    throw redirect({
      to: "/solar-savings-calculator",
      search: valid ? { k: token } : {},
      statusCode: 302,
    });
  },
});
